export class PoisActions {
  static readonly GET_ALL = '[POIS] GET_ALL';
  static readonly GET_ALL_SUCCESS = '[POIS] GET_ALL_SUCCESS';
  static readonly GET_ALL_FAILURE = '[POIS] GET_ALL_FAILURE';
}
